<template>
  <div>
    <div
      class="font-black leading-tight font-display mb-2"
      :class="labelSize"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import ItemMixin from './item-mixin'

const labelSizes = {
  NORMAL: 'normal',
  MEDIUM: 'medium',
  LARGE: 'large'
}

export default {
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelSize () {
      if (this.item.meta.label_size === labelSizes.LARGE) {
        return 'text-4xl md:text-6xl'
      }

      if (this.item.meta.label_size === labelSizes.MEDIUM) {
        return 'text-3xl md:text-4xl'
      }

      return 'text-2xl'
    }
  }
}
</script>
